module.exports = __webpack_public_path__ + "img/84.bc7e03e6.jpg";